var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stockList print-font" }, [
    _c("div", { staticClass: "title print-font" }, [_vm._v("备货清单")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body print-font" },
      [
        _c("div", { staticClass: "table-title" }, [_vm._v("按主订单")]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticClass: "orderDetailTable",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.orderDetailTableData, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "created_at", label: "推送时间", width: "130" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "out_ware_day", label: "要求发货日" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "main_number", label: "主订单号" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "order_number", label: "子订单号", width: "120" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "user_name", label: "客户" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "ruigu_code", label: "锐锢编码" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "self_code", label: "三方编码" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称", width: "280" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "amount", label: "订购数量" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "mo_statusName", label: "状态" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "table-title" }, [_vm._v("按商品信息")]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.orderGoodsInfoData, border: "" }
          },
          [
            _c("el-table-column", { attrs: { type: "index", label: "序号" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "ruigu_code", label: "锐锢编码" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "self_code", label: "三方编码" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名", width: "240" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "total_amount", label: "数量" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "out_ware_day", label: "要求发货日" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btns" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.myPrint }
              },
              [_vm._v("打印")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.exportExcel }
              },
              [_vm._v("导出")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37fb20ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fb20ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/stockList.vue
// module id = null
// module chunks = 